/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete a response definition.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class DeleteResponseDefinitionCommand extends AbstractCommand {
    public _definitionName : string;

    public _oldDefinition : any;

    public constructor(definitionName? : any) {
        if(((typeof definitionName === 'string') || definitionName === null)) {
            let __args = arguments;
            super();
            if(this._definitionName===undefined) this._definitionName = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
            if(this._definitionName===undefined) this._definitionName = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
            (() => {
                this._definitionName = definitionName;
            })();
        } else if(definitionName === undefined) {
            let __args = arguments;
            super();
            if(this._definitionName===undefined) this._definitionName = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
            if(this._definitionName===undefined) this._definitionName = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteDefinitionResponseCommand] Executing.");
        this._oldDefinition = this.doDeleteResponseDefinition(document);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteDefinitionResponseCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldDefinition)) {
            return;
        }
        this.doRestoreResponseDefinition(document, this._oldDefinition);
    }

    /**
     * Deletes the response definition.
     * @param {Document} document
     * @return {*}
     */
    abstract doDeleteResponseDefinition(document : Document) : any;

    /**
     * Restores the response definition previously deleted.
     * @param {Document} document
     * @param {*} oldDefinition
     */
    abstract doRestoreResponseDefinition(document : Document, oldDefinition : any);
}
DeleteResponseDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteResponseDefinitionCommand";
DeleteResponseDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




